import axios from 'axios';

//let baseURL = "https://localhost:44354/api/"//import.meta.env.VITE_API_URL//"https://localhost:44354/api/"

//let baseURL = "https://api.clubf5.com/api/"
let baseURL = import.meta.env.VITE_API_URL
const instance = axios.create({
    baseURL
});

// ============================================
// AUTO-REFRESH DE TOKEN
// ============================================
// No importamos UserService acá para evitar dependencia circular
// (UserService.js importa `API` desde este mismo archivo).

let isRefreshing = false
let refreshSubscribers = []

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb)
}

const onRefreshed = (newToken) => {
  refreshSubscribers.forEach((cb) => cb(newToken))
  refreshSubscribers = []
}

const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.userReprod)
  } catch {
    return null
  }
}

const decodeToken = (access_token) => {
  const payload = JSON.parse(window.atob(access_token.split('.')[1]))
  return {
    cliente: JSON.parse(payload.Cliente),
    nombre: payload.Nombre,
    numSuc: payload.NumSuc,
    role: payload.role,
    usuario: payload.unique_name,
    refresh: payload.tokenRefresh,
    exp: payload.exp
  }
}

const doLogout = () => {
  localStorage.clear()
  // Ajustar la ruta si el login vive en otra parte de la app
  window.location.href = '/'
}

const refreshAccessToken = async () => {
  const user = getCurrentUser()
  if (!user) throw new Error('No hay sesión activa')

  // Request "cruda" con axios (no con `instance`) para no re-entrar
  // en estos mismos interceptors si el refresh también fallara.
  const response = await axios.post(
    `${baseURL}/Token/refresh`,
    { refresh: user.refresh, username: user.usuario },
    { headers: { Authorization: 'Bearer ' + localStorage.access_token } }
  )

  const { access_token } = response.data
  const newUserData = decodeToken(access_token)

  localStorage.access_token = access_token
  localStorage.userReprod = JSON.stringify(newUserData)

  return access_token
}

instance.interceptors.request.use(
  (config) => {
    var token = localStorage.access_token
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error

    // Si no hay respuesta (error de red) o no es 401, no tocamos nada
    if (!response || response.status !== 401) {
      return Promise.reject(error)
    }

    // Evitar recursión: si el que falló fue el propio login o refresh,
    // no hay nada que renovar, la sesión no es válida.
    if (config.url.includes('/Token/refresh') || config.url.includes('/Token/Login')) {
      doLogout()
      return Promise.reject(error)
    }

    // Si esta request ya se reintentó una vez y volvió a fallar,
    // el token nuevo tampoco sirve -> sesión inválida de verdad.
    if (config._retry) {
      doLogout()
      return Promise.reject(error)
    }
    config._retry = true

    if (!isRefreshing) {
      isRefreshing = true
      try {
        const newToken = await refreshAccessToken()
        isRefreshing = false
        onRefreshed(newToken)
      } catch (refreshError) {
        isRefreshing = false
        refreshSubscribers = []
        doLogout()
        return Promise.reject(refreshError)
      }
    }

    // Mientras el refresh está en curso, las demás requests que
    // lleguen con 401 esperan acá y se reintentan todas juntas
    // apenas el token nuevo esté disponible.
    return new Promise((resolve) => {
      subscribeTokenRefresh((newToken) => {
        config.headers.Authorization = 'Bearer ' + newToken
        resolve(instance(config))
      })
    })
  }
)

export default instance